import React from 'react';
import XLight from '@/assets/xLight.svg';
import { useNova } from './NovaContext';

const NovaSuggestionToast: React.FC = () => {
  const { isOpen, suggestions, dismissSuggestion, openNova } = useNova();

  const suggestion = suggestions[0];

  if (isOpen || !suggestion) return null;

  return (
    <div className="fixed right-[100px] bottom-6 w-[280px] max-w-[70vw]" style={{ zIndex: 999999 }}>
      <div className="relative cursor-pointer rounded-2xl bg-white p-4 shadow-lg" onClick={() => openNova({ seedQuery: suggestion.link ? undefined : suggestion.message })}>
        <button
          type="button"
          aria-label="Dismiss suggestion"
          className="absolute top-2 right-2 cursor-pointer"
          onClick={(event) => {
            event.stopPropagation();
            dismissSuggestion(suggestion.suggestionId);
          }}
        >
          <XLight className="h-4 w-4" />
        </button>
        <div className="mb-1 pr-4 text-sm font-bold text-[#1B190F]">{suggestion.title}</div>
        <div className="text-sm text-[#6B6659]">{suggestion.message}</div>
      </div>
    </div>
  );
};

export default NovaSuggestionToast;
